<template>
  <!-- 资讯详情页 -->
  <div class="contentDetail">
    <HeadTitle :url="url"></HeadTitle>
    <!-- <HeadTopInfo :headTitle="$route.meta.title"></HeadTopInfo> -->
    <div style="margin-top: 50px;margin-bottom: 65px;">
      <!-- <header class="header">
        <div>PID:{{ paramsItem.pid }}</div>
      </header> -->
      <main>
        <div class="box">
          <div class="topRow">
            <div class="topRowLeft">
              <div>
                <img class="touXiangImg" :src="paramsItem.banner_image" mode="" />
              </div>
              <div class="headLeft">
                <div class="name">
                  {{ paramsItem.author }}
                </div>
                <div>
                  <div class="car">
                    {{ paramsItem.articleType }}
                  </div>
                </div>
              </div>
            </div>
            <div class="topRowRight" :style="{ 'color': caseFieldColorValue() }">
              {{ caseFieldValue() }}
            </div>
            <!-- <div class="header">
              <div>PID:{{ paramsItem.pid }}</div>
            </div> -->
          </div>
          <div class="content">
            {{ paramsItem.detail.subject }}
          </div>
          <div v-for="(item, index) in allList" :key="index">
            <div v-if="item.type === 'text'">
              <div class="content" v-for="(item_text, item_index) in item.msg_content" :key="item_index">
                {{ item_text.content }}
              </div>
            </div>
            <div v-if="item.type === 'img'">
              <img class="imageBox" :src="item.content" alt="描述" srcset="" />
            </div>
            <div v-if="item.type === 'video'">
              <video class="videoBox" controls :src="item.content"></video>
            </div>
          </div>
          <div class="timeBox">
            <div class="time">
              {{ paramsItem.dateline }}
            </div>
            <div class="operation">
              <div>
                <img src="../../assets/icon/xin-xi.png" alt="" class="listFooterRightImg" />
                <span class="listFooterRightNum">
                  {{ paramsItem.comments }}
                </span>
              </div>
              <div>
                <img src="../../assets/icon/zan.png" alt="" class="listFooterRightImg" /><span class="listFooterRightNum">
                  {{ paramsItem.praises }}</span>
              </div>
              <div>
                <img src="../../assets/icon/yan-jing.png" alt="" class="listFooterRightImg" />

                <span class="listFooterRightNum"> {{ paramsItem.views }}</span>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer class="commFooter" style="height: 100%">
        <div class="replyBox">
          <van-divider content-position="left"
            :style="{ color: 'black', fontWeight: '600', fontSize: '0.42667rem', borderColor: 'black' }">
            {{ listData.length }}条评论
          </van-divider>
        </div>
        <div v-if="listData.length === 0" class="van-empty">
          <div class="van-empty__image"><img src="../../assets/icon/empty-image-default.png"></div>
          <p class="van-empty__description">暂无评论</p>
        </div>
        <div class="box" v-for="item in listData" :key="item.comment_id">
          <van-swipe-cell :before-close="deleteMainCom" :name="item.comment_id">
            <div class="topRow">
              <div class="topRowLeft">
                <div class="headLeft">
                  <div>
                    <span class="name_pl">{{ item.author }}</span> :
                    <span> {{ item.message[0].msg_content }}</span>
                  </div>
                  <div>
                    <div class="uid">{{ item.t_crt_time }}</div>
                  </div>
                </div>
              </div>
            </div>
            <template #right>
              <van-button square text="删除" type="danger" class="delete-button" />
            </template>
          </van-swipe-cell>
          <div class="reply">
            <div class="topRow" v-for="item_reply in item.replyList" :key="item_reply.reply_id">
              <van-swipe-cell :before-close="deleteReplyCom" :name="item_reply.reply_id">
                <div class="topRowLeft">
                  <div class="headLeft">
                    <div>
                      <span class="name_pl">{{ item_reply.from_author }} <span style="color:blue;">回复</span> {{
                        item_reply.to_author }}</span> :
                      <span> {{ item_reply.message[0].msg_content }}</span>
                    </div>
                    <div>
                      <div class="uid">{{ item_reply.dateline }}</div>
                    </div>
                  </div>
                </div>
                <template #right>
                  <van-button square text="删除" type="danger" class="delete-button" />
                </template>
              </van-swipe-cell>
            </div>
          </div>
        </div>
        <!-- </van-list> -->
      </footer>
    </div>
    <!-- 固定底部的操作按钮 -->
    <div class="btnBoottom">
      <div class="operationBtn" v-if="state === 'approved'">
        <div @click="deleteInfo" class="btn1" style="width: 160px">删除</div>
        <div @click="comment" class="btn2" style="width: 160px">评论</div>
      </div>
      <div class="operationBtn" v-else-if="state === 'noApproved'">
        <div @click="deleteInfo" class="btn1">删除</div>
        <div @click="comment" class="btn1">评论</div>
        <!-- <div @click="fail" class="btn2">不通过</div> -->
        <div @click="pass" class="btn2">通过</div>
      </div>
    </div>
    <!-- 底部弹框 -->
    <van-popup v-model="showPopup" position="bottom" round :style="{ height: '40%' }">
      <div class="commonPop">
        <div class="titleTop">管理员评论</div>
        <van-field label="PGC账号" readonly v-model="circle" is-link @focus="showCircle = true" style="font-size: 16px"></van-field>
        <van-action-sheet v-model="showCircle" :round="false" :actions="selectList" @select="onSelect"></van-action-sheet>
        <van-field v-model="textMess" rows="6" autosize label="评论" type="textarea" placeholder="请输入评论文字内容(最多5000字)" />
        <div class="btnRow">
          <van-button type="default" block hairline round
            style="width: 150px;color: rgb(72, 113, 192); border: 1px solid rgb(72, 113, 192);"
            @click="cancelCircle">取消</van-button>
          <van-button block hairline round style="width: 150px; background: rgb(72, 113, 192); color: white"
            @click="oKCircle">确认</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  previewInformationAPI,
  showcommentlistAPI,
  commentlistInformationAPI,
  deleteInformationAPI,
  auditInformationAPI,
  deleteAPI,
} from "@/api/informationManage";

import { Toast, Dialog } from "vant";
import HeadTitle from "../../components/HeadTitle";
// import HeadTopInfo from "./components/HeadTopInfo";
export default {
  name: "InformationManageDetail",
  components: {
    HeadTitle,
    // HeadTopInfo,
  },
  data() {
    return {
      url: "/informationManage",
      allList: [],
      listData: [],
      state: "approved", // 通过当前状态控制下方按钮的显示隐藏，approved表示当前已审批，noApproved表示未审批
      showPopup: false,
      circle: "小迪播报",
      selectList: [],
      showCircle: false,
      textMess: "",
      comment_authorid: "",
    };
  },
  created() {
    if (this.paramsItem.invisibleStr === "待审核") {
      this.state = "noApproved";
    }
  },
  computed: {
    paramsItem() {
      let paramsItem = JSON.parse(this.$route.query.item);
      return paramsItem;
    },
  },
  mounted() {
    this.getList();
    let selectList = JSON.parse(localStorage.getItem("pgcList"));
    if (selectList?.length > 0) {
      this.circle = selectList[0].name;
      this.comment_authorid = selectList[0].value;
      this.selectList = selectList;
    }
    this.loadCommentList(this.paramsItem.pid);
  },
  methods: {
    caseFieldValue() {
      let state = JSON.parse(this.$route.query.item).invisible;
      const stateList = {
        "1": "发布",
        "0": "待审核",
        "-3": "审核不通过",
      };
      return stateList[state] ? stateList[state] : "";
    },
    caseFieldColorValue() {
      let state = JSON.parse(this.$route.query.item).invisible;
      const stateList = {
        "1": "rgb(0, 193, 0)",
        "0": "#d6d62f",
        "-3": "red",
      };
      return stateList[state] ? stateList[state] : "red";
    },
    // 主评论
    getList() {
      const params = {
        pid: this.paramsItem.pid,
      };
      previewInformationAPI(params).then((res) => {
        if (res.status === 200) {
          this.allList = res.data || [];
        }
      });
    },
    // 回复评论列表
    loadCommentList(pid) {
      Toast.loading({ message: "加载中...", forbidClick: true });
      const params = {
        ajaxType: "allPostList",
        pid: pid,
        curr: 1,
        nums: 10,
      };
      showcommentlistAPI(params)
        .then((res) => {
          if (res.data.status === 1) {
            this.listData = res.data.data?.commentlist || [];
          }
        })
        .finally(() => {
          Toast.clear();
        });
    },
    //删除资讯
    deleteInfo() {
      Dialog.confirm({
        title: "删除资讯",
        message: "你确定要删除该条资讯吗?",
      }).then(() => {
        deleteAPI({}, { pid: this.paramsItem.pid }).then((res) => {
          if (res.data.status === 1) {
            Toast.success(res.data.info);
            this.$router.push({
              path: "/informationManage",
              query: { source: "informationManageDetail" },
            });
          } else {
            Toast.fail(res.data.info);
          }
        });
      }).catch(() => { });
    },
    //  删除主评论
    deleteMainCom(e) {
      const id = e.name;
      const position = e.position;
      const instance = e.instance;
      switch (position) {
        case 'left':
        case 'cell':
        case 'outside':
          instance.close();
          break;
        case 'right':
          this.deleteCom({
            pid: this.paramsItem.pid,
            "delete[0]": "c" + id,
          }, instance);
          break;
      }
    },
    //  删除回复评论
    deleteReplyCom(e) {
      const id = e.name;
      const position = e.position;
      const instance = e.instance;
      switch (position) {
        case 'left':
        case 'cell':
        case 'outside':
          instance.close();
          break;
        case 'right':
          this.deleteCom({
            pid: this.paramsItem.pid,
            "delete[0]": "r" + id,
          }, instance);
          break;
      }
    },
    // 删除评论方法
    deleteCom(data, instance) {
      Dialog.confirm({
        title: "删除评论",
        message: "你确定要删除该条评论吗?",
      })
        .then(() => {
          deleteInformationAPI(data, { pid: this.paramsItem.pid }).then((res) => {
            if (res.data.status === 1) {
              Toast.success(res.data.info);
              this.loadCommentList(this.paramsItem.pid);
              instance.close;
            } else {
              Toast.fail(res.data.info);
            }
          });
        })
        .catch(() => { });
    },
    // 评论
    comment() {
      this.showPopup = true;
    },
    // 不通过
    fail() {
      // Dialog.confirm({
      //   title: "评论审核",
      //   message: "是否确认不通过该评论内容?",
      // })
      //   .then(() => {
      //     var data = { pid: this.paramsItem.pid, invisible: 0 }
      //     auditInformationAPI(data).then((res) => {
      //       if (res.data.status === 1) {
      //         this.state = "approved";
      //         Toast.success(res.data.info);
      //       } else {
      //         Toast.fail(res.data.info);
      //       }
      //     });
      //   })
      //   .catch(() => { });
    },
    // 通过
    pass() {
      Dialog.confirm({
        title: "评论审核",
        message: "是否确认通过该评论内容?",
      })
        .then(() => {
          var data = { pid: this.paramsItem.pid, invisible: 1 }
          auditInformationAPI(data).then((res) => {
            if (res.data.status === 1) {
              this.state = "approved";
              Toast.success(res.data.info);
            } else {
              Toast.fail(res.data.info);
            }
          });
        })
        .catch(() => { });
    },
    onSelect(item) {
      this.showCircle = false;
      this.circle = item.name;
      this.comment_authorid = item.value;
    },
    cancelCircle() {
      this.showPopup = false;
      this.circle = "小迪播报";
      this.textMess = "";
    },
    oKCircle() {
      const data = {
        pid: this.paramsItem.pid,
        comment_authorid: this.comment_authorid,
        comment_content: this.textMess,
      };
      if (data.comment_authorid === "") {
        Toast.fail("请选择PCG账号！");
        return;
      }
      if (data.comment_content === "") {
        Toast.fail("请输入评论内容！");
        return;
      }
      commentlistInformationAPI(data, { pid: this.paramsItem.pid }).then(
        (res) => {
          if (res.data.status === 1) {
            Toast.success(res.data.info);
            this.cancelCircle();
            this.loadCommentList(this.paramsItem.pid);
          } else {
            Toast.fail(res.data.info);
          }
        }
      );
    },
  },
};
</script>
<style scoped lang="less">
.contentDetail {
  width: 100%;
  height: 100%;

  .header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 70px;
    width: 100%;

    div {
      font-size: 30px;
      color: #1699d2;
      margin-right: 32px;
    }

    .btnRow {
      button {
        width: 160px;
        height: 60px;
        border-radius: 15px;
        line-height: 60px;
        background: white;
        color: #1699d2;
        border: 1px solid #1699d2;
      }
    }
  }

  .box {
    padding: 10px 30px 30px 10px;
    border-bottom: 2px solid #ececec;
    font-size: 26px;
  }

  .reply {
    margin-left: 90px;
    margin-bottom: 20px;
    border-left: 1px solid #c7c5c5;

    .topRow {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .headLeft {
      margin-left: 8px !important;
      margin-right: 8px !important;
    }

    .uid {
      color: #969799;
    }
  }

  .name_pl {
    color: #eb7350;
  }

  .topRow {
    display: flex;
    justify-content: space-between;

    .topRowLeft {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .touXiangImg {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }

      .headLeft {
        margin-left: 30px;
        font-size: 28px;

        .name {
          font-weight: 500;
          font-size: 30px;
        }

        .car {
          padding: 0px 12px;
          color: #b77d43;
          background-color: #f4f0e4;
          min-width: 105px;
          height: 40px;
          font-size: 26px;
          text-align: center;
          margin-top: 8px;
          line-height: 40px;
        }
      }
    }

    .header {
      width: 50px;
    }

    .topRowRight {
      color: red;
      font-size: 26px;
      margin-top: 10px;
      display: flex;
      text-align: right;
    }
  }

  .content {
    font-size: 30px;
    color: #969799;
    margin: 12px 0px;
  }

  .imageBox {
    display: block;
    width: 100%;
    height: 100%;
    background-size: contain;
    margin-bottom: 10px;
  }

  .videoBox {
    display: block;
    width: 100%;
    height: 500px;
    background-size: contain;
    margin-bottom: 10px;
  }

  .timeBox {
    display: flex;
    justify-content: space-between;
    height: 80px;
    align-items: center;
    font-size: 26px;
    color: #969799;

    .operation {
      display: flex;
      justify-content: flex-end;
      margin-right: 10px;

      div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 16px;

        .listFooterRightImg {
          width: 50px;
          height: 50px;
        }

        .listFooterRightNum {
          display: inline-block;
          margin-left: 8px;
          height: 50px;
          line-height: 50px;
        }
      }
    }
  }

  .listBox {
    /deep/.van-cell__title {
      font-size: 32px;
      color: black;
      font-weight: 500;
    }
  }

  .btnBoottom {
    position: fixed;
    left: 12px;
    right: 0px;
    bottom: 5px;
    z-index: 5;
    width: 100%;
    height: 80px;

    .operationBtn {
      display: flex;
      background: white;
      line-height: 80px;
      justify-content: space-around;

      div {
        font-size: 30px;
        width: 24%;
        text-align: center;
        border: 1px solid rgb(72, 113, 192);
        margin: 0px 12px;
      }

      .btn1 {
        background: white;
        color: rgb(72, 113, 192);
      }

      .btn2 {
        background: rgb(72, 113, 192);
        color: white;
      }
    }
  }

  .commonPop {
    .titleTop {
      height: 120px;
      line-height: 120px;
      font-size: 40px;
      text-align: center;
    }

    .text {
      width: 100%;
      height: 40px;
      display: flex;

      span {
        margin-left: 20px;
        font-size: 32px;
      }
    }

    .btnRow {
      display: flex;
      justify-content: space-around;
      margin-top: 8px;
    }
  }

  .uid {
    color: #969799;
    font-size: 26px;
    margin-top: 12px;
  }

  .contentBottom {
    font-size: 32px;
  }

  .replyBox {
    width: 100%;
    height: 30px;
    font-size: 32px;
    margin: 16px 0px;

    span {
      margin-left: 32px;
      font-weight: 600;
    }
  }
}

.goods-card {
  margin: 0;
}

.delete-button {
  height: 100%;
}

.van-swipe-cell {
  width: 100%;
}
</style>